import React from "react";
import { cn } from "../../styles";
import { BaseElementProps } from "../../props";
export interface FieldSetRowProps {
  /**
   * Label displayed on the left side of the row.
   */
  label: React.ReactNode;

  /**
   * Value displayed on the right side of the row. Can be any React node.
   */
  value?: React.ReactNode;
}

/**
 * A single labeled row used inside the `FieldSet`.
 */
export const FieldSetRow = ({ label, value }: FieldSetRowProps) => {
  return (
    <div className="flex justify-between px-3 py-1.5 even:bg-back-50 even:dark:bg-back-900 rounded-md">
      <div className="mt-0.5 mr-2 uppercase text-xs text-front-500 dark:text-back-400">
        {label}
      </div>
      <div>{value}</div>
    </div>
  );
};
FieldSetRow.displayName = "FieldSet.Row";

export interface FieldSetProps extends BaseElementProps {
  /**
   * The rows of content to display, usually `FieldSet.Row`.
   */
  children?: React.ReactNode;
}

/**
 * A bordered, styled container used to group labeled rows of content (e.g., metadata).
 */
export const FieldSet = ({ children, className }: FieldSetProps) => {
  return (
    <div
      className={cn(
        "bg-back-100 text-front-900 dark:bg-back-800 dark:text-front-50 text-xs sm:text-sm rounded-md shadow-sm",
        "border border-back-200 dark:border-back-700",
        className,
      )}
    >
      {children}
    </div>
  );
};
FieldSet.displayName = "FieldSet";

FieldSet.Row = FieldSetRow;
